module.exports = "<!-- <h6>Area chart</h6> -->\r\n<google-chart #cchart [data]=\"areaChartData\"></google-chart>\r\n"